import { stringify } from 'qs';
import { query } from '@/utils/request';

// 企业申请列表查询
export const getDingTalkApplyList = async (params) => {
  return query(`/zlb/operation/dingtalk/corp/application/list?${stringify(params)}`);
};

// 企业应用审核 - 拒绝
export const refuseApplication = async (data) => {
  return query('/zlb/operation/dingtalk/corp/application/refuse', {
    method: 'POST',
    data,
  });
};

// 企业应用审核 - 开通并同步
export const agreeSyncApply = async (data) => {
  return query('/zlb/operation/dingtalk/corp/application/agree/sync', {
    method: 'POST',
    data,
  });
};

// 企业应用审核 - 关联已有机构
export const relateCorpApply = async (data) => {
  return query('/zlb/operation/dingtalk/corp/application/relate', {
    method: 'POST',
    data,
  });
};

// 企业应用审核 - 重同步
export const resyncApply = async (data) => {
  return query('/zlb/operation/dingtalk/corp/application/resync', {
    method: 'POST',
    data,
  });
};

// 企业申请返回状态枚举
export const getDingTalkApplyStatusList = async () => {
  return query('/zlb/operation/dingtalk/application/status');
};
